export const UI_NS = 'UI_NS';

export const ADD_MEETING = 'ADD_MEETING';
export const ADD_MOOD = 'ADD_MOOD';
export const ADD_NOTE = 'ADD_NOTE';

export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

export const CLOSE_PROFILE = 'CLOSE_PROFILE';
export const OPEN_PROFILE = 'OPEN_PROFILE';

export const CLOSE_FRIENDS = 'CLOSE_FRIENDS';
export const OPEN_FRIENDS = 'OPEN_FRIENDS';

export const CLOSE_SETTINGS = 'CLOSE_SETTINGS';
export const OPEN_SETTINGS = 'OPEN_SETTINGS';

export const CLOSE_WELCOME = 'CLOSE_WELCOME';

export const RESET_STORE = 'RESET_STORE';



/** WEBPACK FOOTER **
 ** ./src/actions/const.js
 **/